// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","nav":"App_nav__Yz+gE","content":"App_content__wwONY","languageButton":"App_languageButton__zV0Ol"};